const CHOOSE_PREVIEW_ID = '__CHOOSE__',
  THIS_OR_THAT_PREVIEW_ID = '__THIS_OR_THAT__',
  RATABLE_PREVIEW_ID = '__RATABLE__',
  QA_PREVIEW_ID = '__QA__',
  QA_ANSWER_PREVIEW_ID = '__QA_ANSWER__';

module.exports = {
  brand:{
    name:'Little Debbie',
    logoURL:require('./little-debbie-logo.png'),
    primaryColor:''
  },
  engagements:[
    {
      id:CHOOSE_PREVIEW_ID,
      kind:'choose',
      text:'Best time for snack time?',
      firstImageURL:require('./MC.jpg'),
      options:[
        {answer:'Hello Sunshine!  Early in the day'},
        {answer:'Keep going!  Middle of the day'},
        {answer:'Finally!  Later in the day'}
      ]
    },
    {
      id:QA_PREVIEW_ID,
      kind:'qa',
      text:'Which Mckee family member was the iconic Little Debbie named after?',
      firstImageURL:require('./qa-question.png'),
      secondImageURL:require('./qa-answer.png'),
      options:[
        {answer:'Sister'},
        {answer:'Daughter'},
        {answer:'Granddaughter',id:'correct'}
      ],
      correctAnswerText:'In 1960',
      correctAnswerId:'correct'
    },
    {
      id:QA_ANSWER_PREVIEW_ID,
      kind:'qa',
      text:'Which Mckee family member was the iconic Little Debbie named after?',
      firstImageURL:require('./qa-question.png'),
      secondImageURL:require('./qa-answer.png'),
      options:[
        {answer:'Sister'},
        {answer:'Daughter'},
        {answer:'Granddaughter',id:'correct'}
      ],
      correctAnswerText:'In 1960, McKee foods founder O.D. McKee was trying to come up with a catchy name for their new family-pack cartons of snack cakes.  O.D. arrived at the name of his 4-year-old granddaughter Debbie.',
      correctAnswerId:'correct'
    },
    {
      id:THIS_OR_THAT_PREVIEW_ID,
      kind:'this_or_that',
      firstImageURL:require('./ToT-top.png'),
      secondImageURL:require('./ToT-bottom.png'),
    },
    {
      id:RATABLE_PREVIEW_ID,
      kind:'ratable',
      text:'Thank you for watching!  What do you think of our video?',
      firstImageURL:require('./video.jpg'),
      videoURL:require('./video.jpg')
    },
  ],
  campaign:{
    feedText:'Little Debbie - a sweet addition to your day!',
    feedImageURL:require('./cover.jpg'),
    completionText:'Thanks for spending time with us.  Keep an eye out for us at your favorite store.',
    ctaText:'Visit our Website',
    ctaLink:'https://littledebbie.com/www',
    ctaColor:'#9a1719',
    useCTA:true
  }
};


// WEBPACK FOOTER //
// ./src/routes/OnboardingDemo/assets/data.js